module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premium_desktop_3_2-28f8cc7c676be5b2d9c6f666c5053a85.webp";